import React, { useEffect, useState } from "react";
import { Col, Row, Container, Button, ProgressBar } from "react-bootstrap";

import StartupHeader from "../../../Components/StartupHeader";
import VideoPlayer from "./VideoPlayer";
import PostVideoModal from "./PostVideoModal";

// const groupName = "Church of Jesus Christ of Latter-day Saints";
// const industryName = "Construction";
// const jobSeekerName = "David Thompson";

const demoVideoParts = [
  {
    categoryTitle: "Job Seeker Sends A Networking Request",
    categoryDescription: "",
    videoUrl:
      "https://elqmq.upcloudobjects.com/demo-videos/mod/bothell-stake_s-v3.mp4",
    videoStyle: "portrait",
    timeStampDetails: [
      {
        title: "Login as a Job Seeker",
        startTime: 0,
        endTime: 32,
        description: "",
        slideText: `**Employed Members:**\n Employed Individuals who are members of The Bothell Stake\n\n**Dave Thompson:**\nSample Construction Job Seeker`,
      },
      {
        title: "Navigate to the Networking Page",
        startTime: 32,
        endTime: 53,
        description: "",
        slideText: `Dave Networks`,
      },
      {
        title: "Filter by Industry and Group",
        startTime: 53,
        endTime: 60 + 24,
        description: "",
        slideText: `Dave Filters by Industry and Group`,
      },
      {
        title: "Select an employed Member to network with",
        startTime: 60 + 24,
        endTime: 60 * 2 + 31,
        description: "",
        slideText: "Dave identifies ideal network candidates",
      },
      {
        title: "Send a Saved Resume with the Networking Request",
        startTime: 60 * 2 + 31,
        endTime: 60 * 2 + 52, // 47
        description: "",
        slideText:
          "Job Seeker Dave sends resume & request to network to chosen Employed Members",
      },
    ],
  },
  {
    categoryTitle: "Employed Member Receives Networking Request",
    categoryDescription: "",
    videoUrl:
      "https://elqmq.upcloudobjects.com/demo-videos/mod/bothell-stake_s-v3.mp4",
    videoStyle: "portrait",
    timeStampDetails: [
      {
        title: "Employed Member logs in to account",
        startTime: 60 * 2 + 52,
        endTime: 60 * 3 + 11,
        description: "",
        slideText:
          "Employed Member & Site Foreman, **Robert Watson**\n logs in",
      },
      {
        title: "Networking Request Notification",
        startTime: 60 * 3 + 11,
        endTime: 60 * 3 + 21,
        description: "",
        slideText:
          "Employed Member Robert received notice of networking request in Messages and in his email",
      },
      {
        title: "View Networking Request in Messages",
        startTime: 60 * 3 + 21,
        endTime: 60 * 3 + 30,
        description: "",
        slideText:
          "Employed Member Robert received notice of networking request in Messages and in his email",
      },
      {
        title: "Navigate to the Connections Page",
        startTime: 60 * 3 + 30,
        endTime: 60 * 3 + 50,
        description: "",
        slideText: "Robert goes to **Connections**",
      },
      {
        title: "Reviews Job Seeker's resume",
        startTime: 60 * 3 + 50,
        endTime: 60 * 4 + 18,
        description: "",
        slideText: `Employed Member Robert reviews Dave's resume, thinking of ways to help`,
      },
      {
        title: "Review 3 response options",
        startTime: 60 * 4 + 18,
        endTime: 60 * 5 + 3,
        description: "",
        slideText: "Employed Member selects 1 of 3 potential responses",
      },
      {
        title: "Respond to the Job Seeker",
        startTime: 60 * 5 + 3,
        endTime: 60 * 5 + 34,
        description: "",
        slideText:
          "Employed Member Robert chooses the 1st response and provides contact information",
      },
    ],
  },
  {
    categoryTitle: "Job Seeker Receives Response",
    categoryDescription: "",
    videoUrl:
      "https://elqmq.upcloudobjects.com/demo-videos/mod/bothell-stake_s-v3.mp4",
    videoStyle: "portrait",
    timeStampDetails: [
      {
        title: "Job Seeker logs in to account ",
        startTime: 60 * 5 + 34,
        endTime: 60 * 5 + 54,
        description: "",
        slideText:
          "Job Seeker received notice in his account **and** in email that the Site Foreman at Evergreen Builders requested contact.",
      },
      {
        title: "Navigate to the Connections Page",
        startTime: 60 * 5 + 54,
        endTime: 60 * 6 + 14,
        description: "",
        slideText: `Job Seeker Dave goes to **Connections**`,
      },
      {
        title: "View the Employed Member's response",
        startTime: 60 * 6 + 14,
        endTime: 60 * 6 + 41,
        description: "",
        slideText:
          "Dave clicks on the Response and the full message is displayed",
      },
      {
        title: "Summary of Networking Example",
        startTime: 60 * 6 + 41,
        endTime: 60 * 7 + 55,
        description: "",
        slideText:
          "There is Real Untapped Potential:\n\n**a.** Employed Members in the Bothell Stake are motivated to assist job seekers in the Bothell Stake. \n\n**b.** Bothell Stake job seekers can network in their industry with those who are motivated to help.",
      },
    ],
  },
];

export default function ShowVideoBothelShare() {
  const [activeSection, setActiveSection] = useState(0);
  const [showPostVideoModal, setShowPostVideoModal] = useState(false);

  const demoVideoUrl =
    "https://elqmq.upcloudobjects.com/demo-videos/mod/bothell-stake_s-v3.mp4";

  const handleDownload = () => {
    // Create an invisible anchor element
    const a = document.createElement("a");
    a.href = demoVideoUrl;
    // Extract filename from URL or use a default name
    const filename = demoVideoUrl.split("/").pop() || "bothell-stake-demo.mp4";
    a.download = filename;
    // Append to body, trigger click, and remove
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    document.body.classList.add("home-page");

    return function cleanup() {
      document.body.classList.remove("home-page");
    };
  }, []);

  const handleOptionSelected = (option) => {
    console.log(`Selected option: ${option}`);
    // Here you can add logic to handle different options
    // For example, navigate to different pages or trigger different actions

    // Close the modal after selection
    setShowPostVideoModal(false);
  };

  return (
    <React.Fragment>
      <StartupHeader />

      <div className="main-content">
        <div className="main-banner" style={{ height: "100vh" }}>
          <div className="dashboard-wrapper resumes-page">
            <Container fluid style={{ maxWidth: "1500px" }}>
              <div className="dashboard-col-bg public-wrapper outline-form">
                <Row className="justify-content-md-center">
                  <Col md={12} className="mx-auto">
                    <h1 className="mb-5 ml-3">JobInfoNetwork</h1>

                    {/* Main Demo Video */}
                    {activeSection === 0 && (
                      <>
                        <VideoPlayer
                          videoUrl={demoVideoUrl}
                          timeStampCategories={demoVideoParts}
                          useLandscape={false}
                          onVideoEnd={() => setShowPostVideoModal(true)}
                        />
                        <div className="text-center mt-4 mb-4">
                          <Button
                            variant="primary"
                            onClick={handleDownload}
                            className="download-btn"
                          >
                            <i className="fa fa-download mr-2"></i>
                            Download Video
                          </Button>
                        </div>
                      </>
                    )}
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </div>
      </div>
      {/* Post Video Modal */}
      <PostVideoModal
        show={showPostVideoModal}
        onHide={() => setShowPostVideoModal(false)}
        onOptionSelected={handleOptionSelected}
      />
    </React.Fragment>
  );
}
